import React, { createContext, useContext, useEffect, useRef } from 'react';
import { webSocketService } from '../services/WebSocketService';

const WebSocketContext = createContext(null);

export function WebSocketProvider({ children }) {
    const messageHandlersRef = useRef({});

    // Context 값 (웹소켓 서비스와 상호작용하는 메서드들)
    const contextValue = {
        // 메시지 핸들러 등록
        registerMessageHandler: (roomId, handler) => {
            if (typeof handler === 'function') {
                messageHandlersRef.current[roomId] = handler;
                webSocketService.registerMessageHandler(roomId, handler);
                return true;
            }
            return false;
        },

        // 메시지 핸들러 제거
        unregisterMessageHandler: (roomId) => {
            if (messageHandlersRef.current[roomId]) {
                delete messageHandlersRef.current[roomId];
                webSocketService.unregisterMessageHandler(roomId);
                return true;
            }
            return false;
        },

        // 연결 설정
        connect: (roomId) => {
            return webSocketService.connect(roomId);
        },

        // 메시지 전송 (중복 방지 포함)
        sendMessage: (roomId, message) => {
            return webSocketService.sendMessageWithDeduplication(roomId, message);
        },

        // 구독
        subscribeToChannel: (roomId, channel) => {
            return webSocketService.subscribeToChannel(roomId, channel);
        },

        // 연결 해제
        disconnect: (roomId) => {
            webSocketService.disconnect(roomId);
        },

        // 연결 상태 확인
        isConnected: (roomId) => {
            return webSocketService.isConnected(roomId);
        }
    };

    // 앱 종료 시 모든 연결 정리
    useEffect(() => {
        return () => {
            webSocketService.cleanupAll();
        };
    }, []);

    return (
        <WebSocketContext.Provider value={contextValue}>
            {children}
        </WebSocketContext.Provider>
    );
}

// 커스텀 훅
export function useWebSocket() {
    const context = useContext(WebSocketContext);
    if (!context) {
        throw new Error('useWebSocket must be used within a WebSocketProvider');
    }
    return context;
}